<template>
  <section ref="heroRef" class="longread-hero">
    <figure v-if="image?.image?.id">
      <AppImageFocal :data="image" :renditions="renditions" :eager="true"/>
    </figure>
  </section>
</template>

<script setup lang="ts">
import {onMounted, reactive, ref, watch} from "vue";
import {useWindowScroll} from "~/composables/useWindowScroll";

const heroRef = ref<HTMLElement>()

const props = defineProps<{
  image: unknown,
}>()

const state = reactive({
  scroll: 0
})

const renditions = [
  { width: 575, height: 874, breakpoint: 'xs' },
  { width: 767, height: 415, breakpoint: 'sm' },
  { width: 991, height: 953, breakpoint: 'md' },
  { width: 1199, height: 649, breakpoint: 'lg' },
  { width: 1920, height: 1039, breakpoint: 'xl' }
]

onMounted(() => {
  // watch for scroll
  const scrollState = useWindowScroll()
  watch(scrollState, (newState) => {
    state.scroll = newState.scroll
  })
})

</script>

<style scoped lang="postcss">
.longread-hero {
  position: fixed;
  top: 0px;
  width: 100%;
  @mixin app-max-header-height;
}
</style>
